import ColorManager from './ColorManager';

export default ColorManager;
